import { ProjectSummary } from "../../Models/ProjectSummary";
import { ActionTypes } from "../ProjectActionTypes";
import { ProjectListAction } from "./ProjectListActions";
import { IProjectListState, initialProjectListState } from "./ProjectListState";
const ProjectListReducer = (
  state: IProjectListState = initialProjectListState,
  action: ProjectListAction
): IProjectListState => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_PROJECTS: {
      console.log(action);
      return { ...state, loaded: false, errorCode: undefined };
    }
    case ActionTypes.GET_PROJECTS_SUCCESS: {
      console.log(action);
      return {
        ...state,
        loaded: true,
        projectsList: payload?.projects as ProjectSummary[],
        originalProjectList: payload?.projects as ProjectSummary[],
        errorCode: undefined,
      };
    }
    case ActionTypes.GET_PROJECTS_ERROR: {
      console.log(action);
      return {
        ...state,
        loaded: true,
        projectsList: [],
        originalProjectList: [],
        errorCode: payload?.errorCode,
      };
    }
    case ActionTypes.ADD_PROJECT: {
      console.log(action);
      return {
        ...state,
        projectsList: [
          ...state.projectsList,
          payload?.project as ProjectSummary,
        ],
        originalProjectList: [
          ...state.projectsList,
          payload?.project as ProjectSummary,
        ],
      };
    }
    case ActionTypes.UPDATE_PROJECT: {
      console.log(action);
      return {
        ...state,
        projectsList: state.projectsList?.map((project) =>
          project.id === payload?.project?.id
            ? { ...project, ...payload.project }
            : project
        ),
        originalProjectList: state.projectsList?.map((project) =>
          project.id === payload?.project?.id ? { ...payload.project } : project
        ),
      };
    }

    case ActionTypes.DELETE_PROJECT: {
      console.log(action);
      return {
        ...state,
        projectsList: state.projectsList?.filter(
          (project) => project.name !== payload?.projectName
        ),
        originalProjectList: state.projectsList?.filter(
          (project) => project.name !== payload?.projectName
        ),
      };
    }

    case ActionTypes.SET_FILTER_PROJECTS: {
      console.log(action);
      return {
        ...state,
        filter: payload?.filter,
        projectsList: payload?.projects as ProjectSummary[],
      };
    }
    case ActionTypes.SET_SEARCH_PROJECTS: {
      console.log(action);
      return {
        ...state,
        searchTerm: payload?.search,
        projectsList: payload?.projects as ProjectSummary[],
      };
    }
    default: {
      return state;
    }
  }
};

export default ProjectListReducer;
